import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

export const getColumnDefs = (): ColDef[] => {
  return [
    {
      colId: 'foreignContactGroupName',
      headerName: t('labelVendor'),
      field: 'foreignContactGroupName',
      filter: 'agTextColumnFilter',
      sort: 'asc',
      flex: 2,
      minWidth: 200,
    },
    {
      colId: 'foreignContactName',
      headerName: t('labelContact'),
      field: 'foreignContactName',
      filter: 'agTextColumnFilter',
      flex: 2,
      minWidth: 150,
    },
    {
      colId: 'foreignContactPhone',
      headerName: t('labelPhone'),
      field: 'foreignContactPhone',
      filter: 'agTextColumnFilter',
      flex: 1,
      minWidth: 120,
    },
    {
      colId: 'foreignCorporateUserEmail',
      headerName: t('labelEmail'),
      field: 'foreignCorporateUserEmail',
      filter: 'agTextColumnFilter',
      flex: 2,
      minWidth: 180,
    },
  ];
};
